export const ADMIN_PATHNAMES = {
  USERS: '/admin/users',
  HOTELOWNERS: '/admin/hotelowners',
  CITIES: '/admin/cities',
  GETCITIES: '/admin/getCities',
}
